import styled from 'styled-components';
import { Text } from '@rsos/components/capstone/base';

export const Checkbox = styled.input.attrs({ type: 'checkbox' })`
  display: flex;
  width: 13px;
  height: 13px;
  margin: 0 10px 0 0;
  flex: 0 0 auto;
`;

export const RowText = styled(Text).attrs({
  color: 'primaryText',
  size: 'normal',
})`
  display: inline-flex;
  flex: 1 1 auto;
`;

export const SectionTitle = styled(Text).attrs({
  size: 'small',
  fontWeight: 'bold',
  color: 'primaryText',
  my: 10,
})``;
